// extracted by mini-css-extract-plugin
export var active = "ProfileMenuBar-module--active--f3339";
export var loadingSpinner = "ProfileMenuBar-module--loading-spinner--de6aa";
export var profileLoginText = "ProfileMenuBar-module--profile-login-text--9633f";
export var profileLoginTextHomepage = "ProfileMenuBar-module--profile-login-text-homepage--b78ef";
export var profileMenuBarContainer = "ProfileMenuBar-module--profile-menu-bar-container--7b800";
export var profileUserTextContainer = "ProfileMenuBar-module--profile-user-text-container--6d524";